import { render, staticRenderFns } from "./new-general-ticket.vue?vue&type=template&id=c159344a&scoped=true&"
import script from "./new-general-ticket.vue?vue&type=script&lang=js&"
export * from "./new-general-ticket.vue?vue&type=script&lang=js&"
import style0 from "./new-general-ticket.vue?vue&type=style&index=0&id=c159344a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c159344a",
  null
  
)

export default component.exports